import { Typography, Box, Button } from "@mui/material";
import { OperatingManualStyleContext } from "../../../../../contexts/OperatingManualStyleContext";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import Image1 from "../../../../../assets/images/operating-manual/4/description4.5.png";
import Image1French from "../../../../../assets/images/operating-manual/4/4.8a-french.png";
import Image2 from "../../../../../assets/images/operating-manual/4/4.8b.png";
import Image2French from "../../../../../assets/images/operating-manual/4/4.8b-french.png";
import Image3 from "../../../../../assets/images/operating-manual/4/4.8c.png";
import Image3French from "../../../../../assets/images/operating-manual/4/4.8c-french.png";
import { ModalCustomConfirm } from "../../../../../styles/muiStylesHelper";
import { PlusIcon } from "../../../../../assets/icons";

const ProgressionAnalysis = () => {
  const { t } = useTranslation();
  const { sectionContainerStyle } = useContext(OperatingManualStyleContext);
  const imgAttributes = [
    [Image1, Image1French],
    [Image2, Image2French],
    [Image3, Image3French],
  ];

  return (
    <Box
      id="progression-analysis"
      sx={{ ...sectionContainerStyle, padding: 3 }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          background:
            "linear-gradient(102deg, #5d5cfe -17.62%, #996ad2 30.87%, #f18e8e 87.31%)",
          color: "white",
          p: 1,
          pl: 4,
          borderRadius: 2,
          mb: 2,
          boxShadow: "0px 0.625rem 3rem 0px rgba(0, 0, 0, 0.06)",
        }}
      >
        <Typography variant="h6" fontWeight="600">
          {`5.8. ${t("operating_manual_progression_analysis_title")}`}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          pl: 4,
          pr: 4,
          gap: 2,
        }}
      >
        <Typography sx={{ color: "text.primary", flex: 1 }}>
          {`${t("operating_manual_progression_analysis_description1")}`}
        </Typography>
        <Box sx={{ ...sectionContainerStyle, mt: 0 }}>
          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Typography sx={{ color: "text.primary", flex: 1 }}>
              {`1. ${t("operating_manual_progression_analysis_description1_1")}`}
            </Typography>

            <Box
              component="img"
              src={imgAttributes[0][t("operating_manual_image_index")]}
              alt="Description Image"
              sx={{
                width: "50%",
                height: "auto",
                ml: 2,
                float: "right",
                borderRadius: 1,
              }}
            />
          </Box>
          <Box
            component="img"
            src={imgAttributes[1][t("operating_manual_image_index")]}
            alt="Description Image"
            sx={{
              width: "fit-content",
              height: "auto",
              ml: 2,
              borderRadius: 1,
            }}
          />

          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Typography sx={{ color: "text.primary" }}>
              {`2. ${t("operating_manual_progression_analysis_description1_2")}`}
            </Typography>

            <Box
              sx={{
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                mx: 1,
                height: "30px",
                width: "30px",
                backgroundColor: "#202338",
                color: "#FFF",
                borderRadius: "4px",
              }}
            >
              <PlusIcon />
            </Box>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Typography sx={{ color: "text.primary", flex: 1 }}>
              {`3. ${t("operating_manual_progression_analysis_description1_3")}`}
            </Typography>

            <Box
              component="img"
              src={imgAttributes[2][t("operating_manual_image_index")]}
              alt="Description Image"
              sx={{
                width: "50%",
                height: "auto",
                ml: 2,
                float: "right",
                borderRadius: 1,
              }}
            />
          </Box>

          <Typography mb={2}>
            {`4. ${t("operating_manual_progression_analysis_description1_4")}`}
            <Button variant="outlined" sx={{ ...ModalCustomConfirm(), mx: 1 }}>
              {t("progress_analysis_generate")}
            </Button>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProgressionAnalysis;
